var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DEFAULT_CONFIG } from './defaults';
export var PROD_CONFIG = __assign(__assign({}, DEFAULT_CONFIG), { NODE_ENV: 'production', URL: 'https://fraimsy.com/', 
    // API config
    API_URL: '/api/', SENTRY: {
        DSN: 'https://bb03c4f684ae411bb13ed1820af6dac8@o284362.ingest.sentry.io/5879726',
    }, STRIPE: {
        KEY: 'pk_live_51IToTBAhVytwlUswYKi84CrqLVSfaugR7oeFDRD1FHkMoBZJX0neXnGoI8lPeJyq113qfPkFNsQI9RBVwinTzw6N00yGTOysxG',
    } });
